module.exports = __webpack_public_path__ + "static/media/bg-1.a6007911.png";